<app-top-nav-login [bbApp]="showbbApp"></app-top-nav-login>

<form #forgotPasswordForm="ngForm">
  <div class="container">
    <div class="login-content content" role="main">
      <div class="login-form">
        <div class="login-heading" >
          <span [hidden]="true"><strong>{{usertype}}</strong></span>
        </div>

        <h1 class="bb-login-heading" aria-label="Login heading"><strong>Forgot/Reset Password</strong></h1>
        <div class="h-30"></div>
        <div class="login-fail fp-box" [hidden]="!errorDivVisible">
          <img src="/assets/tick.svg">
          <span>
            <h2>Password reset link sent</h2>
            <p>If you have an email registered with our system you should receive an email shortly with
            instructions on how to reset your password.</p>

          </span>

        </div>
        @if (inputVisible) {
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Email</mat-label>
            <input matInput [(ngModel)]="forgotPasswordObj.username" class="form-control-textbox" name="Username" #username="ngModel" required />
            @if (username.invalid && username.touched) {
              <mat-error>Field is required</mat-error>
            }
          </mat-form-field>
        }

        @if (inputVisible) {
          <div class="mb-10"></div>
        }
        @if (inputVisible) {
          <div class="form-buttons">
            <input type="submit" (click)="forgotPassword(forgotPasswordForm)" class="bb-login-button" value="Submit" #submitButton aria-label="Submit Button" />
          </div>
        }
        @if (!inputVisible) {
          <div>
            <div class="form-buttons">
              <input type="submit" (click)="goBack()" class="bb-login-button" value="Return to login" #submitButton aria-label="Return to Login"/>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</form>

<app-footer [bbapp]="showbbApp" [showLogos]="true"></app-footer>
